import type { DropdownOption } from "~/screens/Admins/components/DropdownInput";

export const options: DropdownOption[] = [
  { id: "", label: "All" },
  { id: "true", label: "Available for Booking" },
  { id: "false", label: "Unavailable for Booking" },
];

export type ProviderSchedule = {
  id: string;
  name: string;
  scheduleAvailable: boolean;
  bookingConflicts: number;
  scheduleLastModifiedAt: string | null;
};
